//导入封装http
import http from '@/api/request'

//获取半導體 | 資通 | 電子業建廠項目列表
export const reqBzdyList = () => {
  return http({ url: '/gcsj/bzdy/', method: 'get' })
}

//获取汽車產業相關項目列表
export const reqQccyList = () => {
  return http({ url: '/gcsj/qccy/', method: 'get' })
}

//获取航空造船機械項目列表
export const reqHzjyList = () => {
  return http({ url: '/gcsj/hzjy/', method: 'get' })
}

//获取能源石化產業項目列表
export const reqNyshList = () => {
  return http({ url: '/gcsj/nysh/', method: 'get' })
}

//获取制造業生產物流倉儲項目列表
export const reqZzwlList = () => {
  return http({ url: '/gcsj/zzwl/', method: 'get' })
}

//获取礦業 | 鋼鐵 | 鋁業 | 五金制造項目列表
export const reqKtlwList = () => {
  return http({ url: '/gcsj/ktlw/', method: 'get' })
}

//获取食品 | 紡織 | 服飾項目列表
export const reqSffyList = () => {
  return http({ url: '/gcsj/sffy/', method: 'get' })
}

//获取百貨零售 | 商辦 | 高層建築項目列表
export const reqBsgyList = () => {
  return http({ url: '/gcsj/bsgy/', method: 'get' })
}
// 获取最新消息列表
export const reqZxxxList = () => {
  return http({ url: '/zxxx/', method: 'get' })
}
